import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
  API_ERRORS_TRANSLATION_PREFIX,
  DPS_ADMINISTRATION_EMAIL,
  DPS_ADMINISTRATION_PHONE_NUMBER,
  TRANSLATED_API_ERROR_CODES,
} from '@dps/shared/constants';
import { ApiErrorModel, ApiErrorResponse } from '@dps/shared/models';
import { TranslatePipe } from '@ngx-translate/core';
import { DateTime } from 'luxon';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'dps-generic-error-dialog',
  imports: [TranslatePipe],
  templateUrl: './generic-error-dialog.component.html',
  styleUrl: './generic-error-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'flex flex-column align-items-center gap-4 pt-3',
  },
})
export class GenericErrorDialogComponent {
  dialogRef = inject(DynamicDialogRef);
  private dialogService = inject(DialogService);

  readonly dialogData: ApiErrorResponse | null = this.dialogService.getInstance(this.dialogRef)!
    .data;
  readonly formattedErrorDatetime = DateTime.now().toLocaleString(DateTime.DATETIME_SHORT);
  readonly messageTranslationParams = {
    phoneNumber: DPS_ADMINISTRATION_PHONE_NUMBER,
    email: DPS_ADMINISTRATION_EMAIL,
  };

  getErrorTranslationKey(error: ApiErrorModel): string | null {
    return TRANSLATED_API_ERROR_CODES.includes(error.code)
      ? `${API_ERRORS_TRANSLATION_PREFIX}.${error.code}`
      : null;
  }
}
